const INITIAL_STATE = {
  rebateHistory: {},
  membershipDetails: {},
};

export default {
  namespaced: true,

  state: { ...INITIAL_STATE },

  mutations: {
    resetState(state) {
      Object.assign(state, INITIAL_STATE);
    },

    updateRebateHistory(state, data) {
      state.rebateHistory = data;
    },

    updateMembershipDetails(state, data) {
      state.membershipDetails = data;
    },
    
    updateSubmitPolicyInProcess(state, data) {
      state.submitPolicyInProcess = data;
    },
  },

  getters: {
    getRebateHistory: (state) => {
      return state.rebateHistory;
    },

    getMembershipDetails: (state) => {
      return state.membershipDetails;
    },

    getSubmitPolicyInProcess: (state) => {
      return state.submitPolicyInProcess;
    },
  },
};
